import React from 'react';
import './index.scss';
import { PlainText } from '../plainText/plainText';
import aiToolsNavLogo from '../../images/ai-tools-nav.png';
import rightIcon from '../../images/arrow-right.png';
import { ToolsSwitch } from '@umu/umu-types';

const PlatformActionList = () => {
    // 只有未开通 AI Tools 的企业不展示
    const hideAITools =
        Number(
            (window as unknown as { pageData: { enterprise_setting: { setup: { enable_ai_tools: number } } } }).pageData
                ?.enterprise_setting?.setup?.enable_ai_tools,
        ) === ToolsSwitch.notOpen && +window.pageData?.enterprise_setting?.enterprise_id > 0;

    if (hideAITools || location.pathname.startsWith('/ai-tools')) {
        return null;
    }

    return (
        <div className="platform-action-list">
            <div className="to-ai-tools">
                <a href="/ai-tools" target="_blank" rel="noreferrer" className="btn">
                    <img className="ai-tools-logo" src={aiToolsNavLogo} alt="ai-tools-logo" />
                    <PlainText>AI 工具</PlainText>
                    <img className="arrow-right" src={rightIcon} />
                </a>
            </div>
        </div>
    );
};

export { PlatformActionList };
